// extracted by mini-css-extract-plugin
module.exports = {"theme":"#FF6A00"};